<template>
  <div>
    <vs-input class="w-full mb-8" v-model="dataLocal.gameRate" label-placeholder="电游默认返水 (元)" />
    <vs-input class="w-full mb-8" v-model="dataLocal.liveRate" label-placeholder="真人默认返水 (%)" />
    <vs-input class="w-full mb-8" v-model="dataLocal.sportRate" label-placeholder="体育默认返水 (%)" />
    <vs-input class="w-full" v-model="dataLocal.time" label-placeholder="每天系统自动反水的时间" />
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      dataLocal: {}
    }
  },
  methods: {
    getParam() {
      return JSON.stringify(this.dataLocal)
    }
  },
  mounted() {
    this.dataLocal = JSON.parse(this.data)
  }
}
</script>
